import { insuranceLayout } from '@/constants/insuranceLayout'
import type { PageType } from '@/types/models'
import { isNonEmptyString, isUndefined } from './checks'
import {
  isBrowsePageType,
  isCareersPageType,
  isFacetPageType,
  isInsurancePage,
  isLocationPageType,
  isTaxonomyPageType
} from '@/domain/useCases/pageTypeCheck'

const DEFAULT_BACKGROUND_COLOR = 'bg-white border-gray-300'

export const handleTopNavScrollColor = ({
  pageType,
  term,
  hasScrolled = false,
  backgroundColor
}: {
  pageType: PageType
  term: string
  hasScrolled: boolean
  backgroundColor: string
}): string => {
  const shouldUseInsuranceBackgroundStyle =
    isInsurancePage(pageType) &&
    isNonEmptyString(term) &&
    !isUndefined(insuranceLayout[term]?.style)

  if (isNonEmptyString(backgroundColor) && !hasScrolled) {
    return `${backgroundColor} md:border-b-0`
  }

  if (hasScrolled) {
    return DEFAULT_BACKGROUND_COLOR
  }

  if (isNonEmptyString(backgroundColor)) {
    return `${backgroundColor} md:border-b-0`
  }

  if (isBrowsePageType(pageType)) {
    return 'bg-primary-50 lg:bg-white'
  }

  if (isCareersPageType(pageType)) {
    return 'bg-seafoam-100 md:border-b-0'
  }

  if (shouldUseInsuranceBackgroundStyle) {
    return insuranceLayout[term].style
  }

  if (
    isTaxonomyPageType(pageType) ||
    isLocationPageType(pageType) ||
    isFacetPageType(pageType)
  ) {
    return 'bg-seafoam-50'
  }

  return DEFAULT_BACKGROUND_COLOR
}
